import { playStimulusAudio } from '../../../common/stimulus/stimulusButtonActions';

import {
    getWRState,
    getWRPracticeQuestions,
    getWRCorrectResponseIndex,
    getWRStimulusAudio,
} from '../../wrSelectors';
import { getSelectedIndex } from '../../../common/questions/questionsSelectors';

import { PRACTICE } from '../../../constants/assessmentItemType';
import { GENERAL_AUDIO_DELAY } from '../../../constants/time';

export const WR_PRACTICE_POST_AUDIO_CALLBACK = 'WR_PRACTICE_POST_AUDIO_CALLBACK';

export const postAvatarWRAudioAction = () => (dispatch, getStore) => {
    const wrState = getWRState(getStore());
    const questions = getWRPracticeQuestions(getStore());

    const correctResponseIndex = getWRCorrectResponseIndex(wrState, PRACTICE);
    const selectedIndex = getSelectedIndex(questions);
    if (correctResponseIndex !== selectedIndex) {
        const stimulusAudio = getWRStimulusAudio(wrState, PRACTICE);
        return dispatch(playStimulusAudio([stimulusAudio], GENERAL_AUDIO_DELAY));
    }

    return Promise.resolve();
};
